import { Children, isValidElement } from "react";
import numeral from "numeral";

/**
 * Does nothing, returns `undefined`.
 * @returns {undefined}
 */
export const noop = () => {
  // No operation performed.
};

/**
 * Returns a string of form "abc...xyz"
 * @param {string} str string to slice
 * @param {number} n number of chars to keep at front/end
 * @returns {string}
 */
export const getEllipsisText = (str, n = 6, m = 3) => {
  if (str) {
    return `${str.slice(0, n)}...${str.slice(str.length - m)}`;
  }
  return "";
};

/**
 * Gets only the valid children of a component,
 * and ignores any nullish or falsy child.
 *
 * @param children the children
 */
export function getValidChildren(children) {
  return Children.toArray(children).filter((child) => isValidElement(child));
}

/**
 * Stop enter submitting the form.
 * @param keyEvent Event triggered when the user presses a key.
 */
export const preventEnterSubmit = (keyEvent) => {
  if ((keyEvent.charCode || keyEvent.keyCode) === 13) {
    keyEvent.preventDefault();
  }
};

/**
 * Sorts Array of Object by key
 * @param {Object[]} data sortable array
 * @param {string} [sortBy=id] key
 * @returns {Object[]} array of sorted objects by key
 */
export const sortByKey = (data, sortBy = "id") =>
  data.sort((a, b) => {
    const textA = a?.[sortBy]?.toUpperCase() || "";
    const textB = b?.[sortBy]?.toUpperCase() || "";

    return textA < textB ? -1 : textA > textB ? 1 : 0;
  });

/**
 * Remove empty strings, nulls and undefined from object
 * @param {Object} object
 * @returns
 */
export const removeEmptyKeys = (object) =>
  Object.fromEntries(
    Object.entries(object).filter(
      ([, v]) => v !== null && v !== undefined && v !== "",
    ),
  );

/**
 * Get values of keys  from object
 * @param {Object} object
 * @returns
 */
export const swapKeysAndValues = (object) =>
  Object.fromEntries(Object.entries(object).map((pair) => pair.reverse()));

/**
 * Get entries values on keys from object
 * @param {Object} object
 * @returns
 */
export const getValuesMap = (object) =>
  Object.fromEntries(Object.values(object).map((value) => [value, value]));

/**
 * Remove simple elemet from array
 * @param {Array} array
 * @param {any} item
 * @returns
 */
export const deleteItemFromArray = (array, item) =>
  array.filter((element) => element !== item);

/**
 * Create an array of N items
 * @param {number} length
 * @returns
 */
export const fill = (length) => Array(length).fill("");

/**
 * Format thousands number to user-friendly format
 * @param {number} number
 * @returns
 */
export function formatThousandCounter(number) {
  const isInteger = number % 1 === 0;

  const format = isInteger ? "0a" : "0.0a";

  return numeral(number).format(format);
}

/**
 * Replace breaks from the text
 * @param {string} text
 * @returns string
 */
export function replaceBreaks(text) {
  return text.replace(/\n\s*\n/g, "\n\n");
}
